import * as _ from 'underscore';

import { TimeService } from '../time/time.service';

export class Cached {
    constructor(data: any, timeService: TimeService) {
        _.extend(this, {
            data,
            updated: timeService.getCurrentTime(),
        });
    }
}
